module.exports = __webpack_public_path__ + "img/placeholder-page.87123d41.svg";